export enum ReleaseFlag {
  TapApp = 'tap_app',
}
